import type { AutofillTarget } from "@/pages/settings/components/dealsSettings/StageStudio/workflow/hooks/autofillTarget";
import type { OnboardingWorkflowItemInput } from "@/pages/settings/components/contractsSettings/types";

export const CONTRACT_WORKFLOW_ITEM_AUTOFILL_TARGET: AutofillTarget = {
  kind: "contractWorkflowItem",
  routes: {
    createField: "settings/contracts/stages/workflows/items",
    field: "settings/contracts/stages/workflows/items/itemById",
    instructions:
      "settings/contracts/stages/workflows/items/autofillInstructions",
    testRuns: "settings/contracts/stages/workflows/items/autofillTestRuns",
    testRunById: "settings/contracts/stages/workflows/items/autofillTestRunById"
  },
  fieldIdParam: "itemId",
  buildDraft: ({ groupId, name, fieldType, helpText }) =>
    ({
      contractWorkflowId: groupId,
      name,
      responseType: {
        value: "none",
        type: fieldType,
        setValueType: null,
        unit: null
      },
      isGuardrails: false,
      isManual: true,
      filledByDreamer: false,
      isDraft: true,
      tooltipText: helpText
    }) satisfies OnboardingWorkflowItemInput,
  // The section is already behind the contract onboarding autofill flag.
  requiresTestFlag: false,
  triggerTypesEditable: true,
  copyKeys: {
    tooltip: "contract.tooltip",
    recordLabel: "contract.test.recordLabel",
    recordPlaceholder: "contract.test.recordPlaceholder",
    noResult: "contract.test.noResult"
  }
};
